import React from 'react';

import queryString from 'query-string';
import { RouteComponentProps, Switch, withRouter } from 'react-router';
import { Route } from 'react-router-dom';

import { AsyncApplicationPage } from './application/async-application-page';
import { AuthenticationRequiredRoute } from './authentication/authentication-required-route';
import { EndToEndUserLogin } from './end-to-end/end-to-end-user-login';
import { HomePageLandingRedirect } from './home-page-landing-redirect';
import * as WebRoutes from './web-routes';

import { HIRING_PERMISSION } from './util/permissions';
import { AuthorizeService } from './widgets/authorize-service';
import { MessagePageWithLogin } from './widgets/message-page-with-login';
import { NotFoundPage } from './widgets/not-found-page';
import PageContainer from './widgets/page-container';

const MainApp = () => (
  <PageContainer>
    <Switch>
      <Route path={WebRoutes.LOGGED_OUT_ROUTE} render={() => <MessagePageWithLogin />} />
      <AuthenticationRequiredRoute
        exact
        path={WebRoutes.homePageLandingRedirectRoute()}
        render={(props: RouteComponentProps) => <HomePageLandingRedirect {...props} />}
      />
      <AuthenticationRequiredRoute
        path={WebRoutes.jobApplicationPageRoute()}
        requiredHiringPermission={HIRING_PERMISSION.ALL}
        render={(props: RouteComponentProps<JobApplicantRouteProps>) => {
          const queryParams = queryString.parse(props.location.search);
          return (
            <div className="u-width-100 u-padding-bottom-clearChat">
              <AsyncApplicationPage
                jobApplicantId={parseInt(props.match.params.jobApplicantId, 10)}
                tab={queryParams.tab}
                isFullscreen
              />
            </div>
          );
        }}
      />
      <AuthenticationRequiredRoute
        path={WebRoutes.authorizeServiceRoute()}
        render={(props: RouteComponentProps<OAuthAuthorizationRoute>) => {
          const queryStringCode = queryString.parse(props.location.search).code;
          let code: string | null = null;
          if (!queryStringCode) {
            return <NotFoundPage />;
          }
          if (Array.isArray(queryStringCode)) {
            [code] = queryStringCode;
          } else {
            code = queryStringCode;
          }
          return <AuthorizeService service={props.match.params.service} code={code} />;
        }}
      />
      <Route path="/end-to-end-user-login" component={EndToEndUserLogin} />
      <AuthenticationRequiredRoute render={() => <NotFoundPage />} />
    </Switch>
  </PageContainer>
);

export default withRouter(MainApp);
